import ProjectListContainer from "../../../../Components/Applications/Project/ProjectList/ProjectListContainer";

const ProjectList = () => {
  return <ProjectListContainer />;
};

export default ProjectList;
